export default function (app) {
  app.controller('klCustomerCenterUncancelCtrl', [
    '$state',
    '$window',
    'klSubscriptionService',
    function ($state, $window, SubscriptionService) {
      this.isLoading = false;
      this.subscriptionNumber = $state.params.subscriptionNumber;
      this.abort = function () {
        $state.go('subscription');
      };
      this.confirm = () => {
        this.isLoading = true;
        SubscriptionService.reactivate(this.subscriptionNumber)
          .then((response) => {})
          .then(() => {
            this.isLoading = false;
            $window.location.reload();
          });
      };
    },
  ]);
}
